export const STRIPE_INTEGRATION_FEATURE_FLAG_KEY = 'stripe_integration'
export const PUSH_NOTIFICATIONS_FEATURE_FLAG_KEY = 'push_notifications'
